<template>
  <error-component v-bind="$attrs" v-slot="{touch, faulty}">
    <input
      type="password"
      class="inp"
      v-bind="$attrs"
      :value="value"
      :class="{faulty}"
      @input="$emit('input', $event.target.value)"
      @blur="touch"
    />
  </error-component>
</template>

<script>
import ErrorComponent from "@/components/ErrorComponent";

export default {
  props: {
    value: String,
  },
  components: {
    ErrorComponent
  }
}
</script>

<style>

</style>